import { NgModule } from '@angular/core'; // A wrapper around an NgModule that associates it with the providers
import { BrowserModule, Title } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
//import { HeaderComponent } from './header/header.component';
//import { FooterComponent } from './footer/footer.component';
import { NotFoundComponent } from './not-found/not-found.component';

import { AuthModule } from './auth/auth.module';
import { CoreModule } from './core/core.module';
import { AuthService } from './auth/auth.service';
// import { ContactService } from './contact.service';
// import { MessageService } from './message.service';

import { CallbackComponent } from './callback/callback.component';

//import { ContactComponent } from './contact/contact.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    // HeaderComponent,
    // FooterComponent,
    CallbackComponent,
    NotFoundComponent
    //ContactComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AuthModule.forRoot(),
    CoreModule.forRoot() // need to call forRoot() in order to provide their services + ensure that they are only provided once
  ],
  providers: [Title, AuthService],
  bootstrap: [AppComponent]
})
export class AppModule { }
